export const formatNumber = (
  value: string | number | undefined | null,
  decimalPoints = 2,
  shorten = false,
  spacer = true,
  trimmer = false,
  truncate = false
) => {
  'worklet';

  if (value == null) {
    return '...';
  }

  let numericValue = Number(value).toFixed(decimalPoints);
  if (truncate) numericValue = Math.trunc(Number(value)).toString();

  const number = Number.parseFloat(numericValue.toString());
  if (Number.isNaN(number)) {
    return '...';
  }
  if (shorten) {
    if (number >= 1.0e7) return `${Math.abs(number) / 1.0e6}m`;
    if (number >= 1.0e4) return `${Math.abs(number) / 1.0e3}k`;
  }
  if (spacer) {
    return number.toFixed(decimalPoints)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  // NOTE: added this because when value is 0.00354... for example the floor changes the number to only display 0's
  if (trimmer && spacer) {
    const beforeDotValue = numericValue
      .toString()
      .substr(0, numericValue.toString().indexOf('.'));
    const slicedValue = numericValue
      .toString()
      .substr(value.toString().indexOf('.'), decimalPoints + 1);
    const fullValue = beforeDotValue + slicedValue;

    return fullValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  if (trimmer && !spacer) {
    const beforeDotValue = numericValue
      .toString()
      .substr(0, numericValue.toString().indexOf('.'));
    const slicedValue = numericValue
      .toString()
      .substr(numericValue.toString().indexOf('.'), decimalPoints + 1);
    const fullValue = beforeDotValue + slicedValue;

    return fullValue.replace(/\B(?=(\d{3})+(?!\d))/g, '');
  }

  return number.toFixed(decimalPoints)
};

const factorsForDecimals = (decimalPoints: number) => {
  return Math.pow(10, decimalPoints);
};

export const roundDown = (value: number, decimals: number) => {
  const factor = factorsForDecimals(decimals);
  return Math.trunc(value * factor) / factor;
};

export const round = (value: number, decimals: number) => {
  const factor = factorsForDecimals(decimals);
  return Math.round(value * factor) / factor;
};

export const isWholeNumber = (value: string, decimals = 2) =>
  parseFloat(value).toFixed(decimals).split('.')[1] === '0'.repeat(decimals);

export const getCents = (value: number) => {
  let precision = 2;
  // RS: NB: This adjusts the precision for fiat cents values when the amount is less than 0.00, to show 6 decimals
  if (value <= 0.001 && value >= 0.000001) {
    precision = 6;
  }

  const cents = value.toFixed(precision).toString().split('.')[1];
  return cents !== '...' ? cents : '0.00';
};

export const formatPercentage = (
  value?: number,
  showPercentageSymbol = true
) => {
  if (!value) return showPercentageSymbol ? '0.00%' : '0.00';

  const absoluteValue = Math.abs(value);
  /* https://stackoverflow.com/questions/10015027/javascript-tofixed-not-rounding
  toFixed() wasn't intended for rounding, but is good enough for this use case
  if we can live with .005 rounding down instead of up
  e.g. 35.855*100 = 3585.4999999999995
  */
  const absoluteValueRounded = absoluteValue.toFixed(2);

  const formattedInteger = absoluteValueRounded
    ?.split('.')?.[0]
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const formattedDecimal = absoluteValueRounded?.split('.')?.[1] || '00';

  return `${formattedInteger}.${formattedDecimal?.slice(0, 2)}${showPercentageSymbol ? '%' : ''
    }`;
};

export const getDecimals = (value?: number): number => {
  if (!value || value === null || value === undefined) return 0;
  const decimals = parseInt(`${100 * (value - parseInt(`${value}`))}`);
  return decimals;
};

export const getInteger = (value?: number): number => {
  if (!value || value === null || value === undefined) return 0;
  const integer = parseInt(`${value}`);
  return integer;
};

export const addCommas = (num: string) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const removeNonNumeric = (num: number) =>
  num.toString().replace(/[^0-9]/g, '');

export function addThousandSeparator(x: number | null, separator: string = " ") {
  return x?.toString()?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, separator);
}